'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _createTheme = require('./createTheme'),
    _createTheme2 = _interopRequireDefault(_createTheme),
    _propTypes3 = require('../propTypes');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme ? props.theme : (0, _createTheme2.default)();
  return _react2.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, props.children);
};

ThemeProvider.propTypes = {
  children: _propTypes2.default.node,
  theme: _propTypes3.themeShape
}, exports.default = ThemeProvider;